<template>
  <div class="fadeInTopLeft" id="homePageContainer">
<!--    <el-row>-->
<!--      <el-col :span="15">-->
<!--        <div class="home-panel-wrapper-left">-->
<!--          <PendingItemsComponent/>-->
<!--        </div>-->
<!--       <div class="home-panel-wrapper-left" >-->
<!--         <CaseShareComponent/>-->
<!--       </div>-->
<!--        <div class="home-panel-wrapper-left">-->
<!--          <PrivatePlotComponent/>-->
<!--        </div>-->
<!--      </el-col>-->

<!--      <el-col :span="9">-->
<!--        <div class="home-panel-wrapper-right">-->
<!--          <AddressBookComponent/>-->
<!--        </div>-->
<!--        <div class="home-panel-wrapper-right">-->
<!--          <TriangleComponent/>-->
<!--        </div>-->
<!--        <div class="home-panel-wrapper-right">-->
<!--          <LoudSpeakerComponent/>-->
<!--        </div>-->
<!--        <div class="home-panel-wrapper-right" >-->
<!--          <ForumComponent/>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
    <el-row>
<!--      <el-col :span="15">-->
<!--        <div class="home-panel-wrapper-left">-->
<!--          <CaseShareComponent/>-->
<!--        </div>-->
<!--        <div class="home-panel-wrapper-left" >-->
<!--          <TriangleComponent/>-->
<!--        </div>-->
<!--        <div class="home-panel-wrapper-left">-->
<!--          <PrivatePlotComponent/>-->
<!--        </div>-->
<!--      </el-col>-->

      <el-col :span="9">
        <div class="home-panel-wrapper-right">
          <AddressBookComponent/>
        </div>
        <div class="home-panel-wrapper-right">
          <PendingItemsComponent/>
        </div>
        <div class="home-panel-wrapper-right">
          <LoudSpeakerComponent/>
        </div>
        <div class="home-panel-wrapper-right" >
          <ForumComponent/>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <FooterComponent></FooterComponent>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import CaseShareComponent from '../../components/home/CaseShareComponent'
  import PendingItemsComponent from "../../components/home/PendingItemsComponent";
  import AddressBookComponent from "../../components/home/AddressBookComponent";
  import TriangleComponent from "../../components/home/TriangleComponent";
  import LoudSpeakerComponent from "../../components/home/LoudSpeakerComponent";
  import PrivatePlotComponent from "../../components/home/PrivatePlotComponent";
  import ForumComponent from "../../components/home/ForumComponent";
  import {mapState} from "vuex";
  import FooterComponent from "../../components/home/FooterComponent";
    export default {
      name: "Main",
      components:{
        FooterComponent,
        LoudSpeakerComponent,
        TriangleComponent,
        AddressBookComponent,
        CaseShareComponent,
        PendingItemsComponent,
        PrivatePlotComponent,
        ForumComponent,
      },
      data(){
        return{
          superPower: false,
          unApproveMember: true,
        }
      },
      watch:{
        userPower(newVal){
          this.superPower = this.$store.state.userPowerStore.superPower
        },
      },
      created() {

      },
      mounted(){
        this.getAuth()
        let dom = document.getElementById("homePageContainer")
        dom.setAttribute("class","fadeInTopLeft")
        setTimeout(()=>{
          //需要将这个动画清除,否则会影响其他动画不执行
          dom.setAttribute("class","")
        },800);
      },

      methods:{
        getAuth() {
          //调用方法之后获取权限设置在vuex中
          this.$store.dispatch("getUserPower").then(value => {
            //获取用户部门管理权限
            this.superPower = this.$store.state.userPowerStore.superPower
            // this.unApproveMember = this.$store.state.userPowerStore.superPower
          })
        },
      },

      computed: {
        ...mapState({
          userPower: state => state.userPowerStore.userPower,
          unApproveMember: satte => state.userPowerStore.unApproveMember
        }),
      }
    }
</script>

<style scoped>

.fadeInTopLeft{
  animation-fill-mode: forwards;
  animation-duration: 800ms;
  animation-name: fadeInTopLeft;
}

@keyframes fadeInTopLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }

}
.fadeOutTopLeft{
  animation-fill-mode: forwards;
  animation-duration: 800ms;
  animation-name: fadeOutTopLeft;
}

@keyframes fadeOutTopLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/home/Main.vue